module.exports = __webpack_public_path__ + "img/fish2.4085331c.png";